// extracted by mini-css-extract-plugin
export default {"loader":"tableLoader_loader__LXeRa","loading":"tableLoader_loading__Sa0Sk"};